
















import { Observer } from 'mobx-vue'

import { Component, Vue } from 'vue-property-decorator'

@Observer
@Component({
  components: {
    'sb-staking': () => import('./sb-staking.vue'),
    'ste-staking': () => import('./ste-staking.vue'),
    'usdt-staking': () => import('./usdt-staking.vue')
  }
})
export default class extends Vue {}
